import { useState } from "react";
import Layout from "@/components/Layout";
import Hero from "@/components/home/Hero";
import ServicesGrid from "@/components/home/ServicesGrid";
import SolutionsShowcase from "@/components/home/SolutionsShowcase";
import GamesShowcase from "@/components/home/GamesShowcase";
import WhyChooseUs from "@/components/home/WhyChooseUs";
import StatsPartners from "@/components/home/StatsPartners";
import Testimonials from "@/components/home/Testimonials";
import ContactCTA from "@/components/home/ContactCTA";
import DemoDialog from "@/components/DemoDialog";

// Home wraps Layout and uses its DemoDialog by controlling from a local state via a bus.
// Simpler: we bypass and use a local DemoDialog controlled here for the CTAs in sections
// that live under Layout — Layout already renders a DemoDialog. We open that via CustomEvent.

function openLayoutDemo() {
  window.dispatchEvent(new CustomEvent("alphatech:open-demo"));
}

export default function Home() {
  return (
    <Layout>
      <Hero onOpenDemo={openLayoutDemo} />
      <ServicesGrid onOpenDemo={openLayoutDemo} />
      <SolutionsShowcase onOpenDemo={openLayoutDemo} />
      <GamesShowcase />
      <WhyChooseUs />
      <StatsPartners />
      <Testimonials />
      <ContactCTA onOpenDemo={openLayoutDemo} />
    </Layout>
  );
}
